/**
 * Internal dependencies
 */
import OneLayer from 'src/components/common/checkList/one-layer';

function ServiceFilterContent({ selectList, onFilterChange, list }) {
  return (
    <OneLayer
      action={(serviceId) => {
        onFilterChange({
          type: 'SERVICES',
          value: serviceId,
        });
      }}
      list={list}
      selectList={selectList}
      isSearchOn
    />
  );
}

export default ServiceFilterContent;
